// Button Component
import { forwardRef, ReactNode } from 'react';
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
} from '@mui/material';

interface ButtonProps extends MuiButtonProps {
  isLoading?: boolean;
  loadingText?: string;
  children?: ReactNode;
  disabled?: boolean;
  startIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, isLoading, loadingText, disabled, startIcon, ...props }, ref) => {
    return (
      <MuiButton
        ref={ref}
        {...props}
        disabled={disabled || isLoading}
        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : startIcon}
      >
        {isLoading && loadingText ? loadingText : children}
      </MuiButton>
    );
  }
);

Button.displayName = 'Button';

export default Button;
